export interface SearchBibliographyMarcRequest {
  marcType: string
  marcNo: string
  tooli: boolean
}

export function SearchBibliographyMarcRequestToJSON(
  value: SearchBibliographyMarcRequest
): any {
  return {
    marc_type: value.marcType !== '' ? value.marcType : undefined,
    marc_no: value.marcNo !== '' ? value.marcNo : undefined,
    tooli: value.tooli ?? undefined
  }
}
